module.exports = __webpack_public_path__ + "static/media/24_tn.6bb29291.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/24_tn.jpg
// module id = 454
// module chunks = 0